import _ from "lodash";
const stepListMapModalType = {
  ADD_FROM_TODDLE_LIBRARY: [
    {
      id: "unitSelection",
      label: "unitPlan:select_a_unit",
      filters: ["UNIT_TYPE", "SUBJECT", "GRADE"],
    },
    {
      id: "LeSelection",
      label: "unitPlan:leSelectionLabel",
    },
  ],
  ADD_FROM_OTHER_UNIT: [
    {
      id: "unitSelection",
      label: "unitPlan:select_a_unit",
      filters: ["COURSE", "UNIT_TYPE"],
    },
    {
      id: "LeSelection",
      label: "unitPlan:leSelectionLabel",
    },
  ],
};

export const getModalHeaderText = ({
  modalType,
  groupType,
  t,
  curriculum_type,
}) => {
  switch (modalType) {
    case "ADD_FROM_TODDLE_LIBRARY":
      return t(
        "common:import_learning_expereince_assessment_from_curriculum_library",
        {
          curriculum: curriculum_type,
        }
      );
    case "ADD_FROM_OTHER_UNIT":
      if (groupType === "WORKSHEET") {
        return t("common:import_worksheet_from_other_unit_of_this_ay");
      }
      return t(
        "common:import_learning_experience__assessment_from_other_unit_of_this_ay"
      );
  }
};

const getStepList = ({ t, modalType, groupType }) => {
  _.set(
    stepListMapModalType,
    ["ADD_FROM_OTHER_UNIT", "1", "label"],
    groupType === "WORKSHEET"
      ? "unitPlan:select_worksheet_to_import"
      : "unitPlan:leSelectionLabel"
  );
  return _.map(_.get(stepListMapModalType, modalType, []), step => {
    return { ...step, label: t(step.label) };
  });
};

export const getStepListMemoized = _.memoize(getStepList, params =>
  JSON.stringify(params)
);
